import React from "react";
import LayoutWrapper from "./components/layout/LayoutWrapper";
import { Navigate, Outlet } from "react-router-dom";
import { useSelector } from "react-redux";
import { useSSEProfile } from "./hooks/useSSEProfile";

const AppWrapper = () => {
  const isAuth = useSelector((state) => state.auth.isAuthenticated);
  useSSEProfile();

  return isAuth ? (
    <LayoutWrapper>
      <Outlet />
    </LayoutWrapper>
  ) : (
    <Navigate to="login" />
  );
};

export default AppWrapper;
